<div class="form-group">
  <label [hidden]="hideLabel" for="SelectedObject">{{ labelText }}</label>
  <ng-select
    required
    [items]="selectionList$ | async"
    bindLabel="Name"
    bindValue="Id"
    [multiple]="false"
    [hideSelected]="true"
    [loading]="selectionListLoading"
    [typeahead]="selectionListInput$"
    [(ngModel)]="selectedObjectId"
    name="SelectedObject"
    placeholder="{{selectObjectText}}"
    (change)=selectedObjectChanged($event)
    [searchable]="true"
    (search)="searchChanged($event)"
    [searchFn]="this.returnTrue">

    <!-- Exact Online allows two relations to share a name, so the code is shown beside it. It is
         what tells them apart, and without it a choice between duplicates is a guess. -->
    <ng-template ng-label-tmp let-item="item">
      {{ item.Name }}<span *ngIf="item.Code" class="text-muted"> ({{ item.Code }})</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.Name }}<span *ngIf="item.Code" class="text-muted"> ({{ item.Code }})</span>
    </ng-template>
  </ng-select>
</div>
